<template>
  <div :class="{ 'pb-14': sticky }">
    <div
      :class="
        sticky
          ? 'fixed top-0 inset-x-0 z-50 pb-4 pt-safe-area-top px-4 bg-white border-b border-gray-100 w-full'
          : 'py-4 cursor-pointer'
      "
    >
      <button
        class="flex items-center text-gray-900"
        :class="{ 'font-semibold text-20 mt-4': sticky }"
        @click="$emit('back')"
      >
        <svg role="presentation" focusable="false" tabindex="-1" class="rotate-90 mr-4 icon-md"   alt="" svg-inline  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 19">
  <path fill="currentColor" fill-rule="evenodd"
    d="M.8 1.18a2.26 2.26 0 0 1 3.2 0L16 13.2 28.03 1.18a2.26 2.26 0 0 1 3.2 3.2L17.6 17.97c-.88.9-2.31.9-3.2 0L.8 4.39a2.26 2.26 0 0 1 0-3.2Z"
    clip-rule="evenodd" />
</svg>
        {{ label ?? $t('back') }}
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{ label?: string; sticky?: boolean }>()
defineEmits(['back'])
</script>
